
import { useState, useRef } from "react";



function Csv(props)
{

    
    function utf8_to_b64( str ) {
        return window.btoa(unescape(encodeURIComponent( str )));
    }
    
    function b64_to_utf8( str ) {
        return decodeURIComponent(escape(window.atob( str )));
    }

    const goCSV = () =>
    {
 
        var txtBuffer  = "";
        
        const rows = props.tabRef.current?.rows;
        if(!rows)
        {
            console.log("tabRef null");
            return; 
        }

        Array.from(rows).forEach(row => {

        
            var clsName = row.className;
           
            const cells = Array.from(row.cells);
            cells.forEach(cell => {

               //   console.log(cell);

                  var txt = cell.innerHTML+"";
                  var tdClsName = cell.className;
                  var childElementCount = cell.childElementCount; //

 

                  txt = txt.replace(";"," ");
                  txt = txt.replace("&nbsp;"," ");
                  txt = txt.replace("&nbsp"," ");
                  txt = txt.replace(/[\r\n]/g," "); 
                  //txt = txt.replace(/[\n]/g," ");                                     

                  
                 

                  if(childElementCount == 0) 
                  {
                    txtBuffer = txtBuffer +   txt + ";";
                  }else
                  {
                    txtBuffer = txtBuffer       + ";";
                  }


            });

            txtBuffer = txtBuffer + "\r\n";

          });

          
          txtBuffer = "\ufeff"+txtBuffer; //code utf 

          var encodedString = utf8_to_b64(txtBuffer);
    
        //  document.location.href = "data:text/csv;base64," + encodedString;

          var title = "elizak.csv";
          if(props.title != undefined) title = props.title;

          if(!title.includes(".csv") )
          {
              title = title + ".csv";
          }

          var anchor = document.createElement('a');
          anchor.href = "data:text/csv;base64," + encodedString;     
          anchor.target="_blank";
          anchor.download = title;
          anchor.click();

    }


    return (
        <span onClick={goCSV} className="plg_link">&nbsp;&nbsp;CSV&nbsp;&nbsp;</span>
    )


}



export default Csv;